module.exports = __webpack_public_path__ + "6ccc1ed85229f7c88b07bbbeefe5214d.gif";


//////////////////
// WEBPACK FOOTER
// ./node_modules/slickgrid-qgrid/images/collapse.gif
// module id = 163
// module chunks = 0